export default __webpack_public_path__ + "static/media/right-chevron.45d8549f.svg";